import Page from '../page';
import SearchComponent from '../../components/search/search-component';
import FacetSearchComponent from '../../components/search/facet-search-component';

export default class TireSearchPage extends Page {
  private searchComponents: SearchComponent[] = [];

  constructor(body: JQuery<HTMLBodyElement>) {
    super();

    const searchComponentEls = body[0].querySelectorAll('.js-searchComponent');
    if (searchComponentEls.length) {
      for (let i = 0; i < searchComponentEls.length; i++) {
        this.searchComponents.push(new FacetSearchComponent(searchComponentEls[i] as HTMLElement));
      }
    }
  }
}
